import { render } from "./SelfAssessmentV2CloseConfirm.vue?vue&type=template&id=6ee5dcb4&scoped=true"
import script from "./SelfAssessmentV2CloseConfirm.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2CloseConfirm.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2CloseConfirm.vue?vue&type=style&index=0&id=6ee5dcb4&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee5dcb4"]])

export default __exports__